import _ from "lodash";
let type_name = {
  pm25: "PM₂.₅",
  pm10: "PM₁₀",
  wind_speed: "风速",
  wind_direction: "风向",
  wendu: "温度",
  shidu: "湿度",
  particle_size_ratio: "粒径比例",
  alarm_count: "报警次数",
  gf_1: "国控点",
  gf_2: "省控点",
  gf_3: "市控点",
  gf_4: "街镇控点",
  point: "微站",
  cloud: "云图",
  jiezhen: "街镇色块",
  quxian: "区县色块",
  grid: "网格色块",
  real: "秒",
  min: "分钟",
  hour: "时均",
  day: "日均",
  week: "周均",
  period: "旬均",
  month: "月均",
  year: "年均"
};

let zoomCircleSize = {
  8: 16,
  9: 16,
  10: 16,
  11: 16,
  12: 16,
  13: 17,
  14: 18,
  15: 18,
  16: 18,
  17: 18,
  18: 18,
  19: 18,
  20: 18
};

let timeSpace = {
  real: 3600 * 6,
  min: 3600 * 6,
  hour: 3600 * 24 * 5,
  day: 3600 * 24 * 30,
  week: 3600 * 24 * 7 * 8,
  period: 3600 * 24 * 10 * 8,
  month: 3600 * 24 * 31 * 8,
  year: 3600 * 24 * 365 * 2
};

let time_range_std = {
  min: [0, 2880],
  hour: [2880, 14400],
  day: [14401, 345600],
  week: [345601, 2419200],
  period: [345601, 2419200],
  month: [2419201, 9676800],
  year: [9676801, 116121600]
};

let time_unit_info = {
  min: 60,
  hour: 3600,
  day: 3600 * 24,
  week: 3600 * 24 * 7,
  period: 3600 * 24 * 10,
  month: 3600 * 24 * 30,
  year: 3600 * 24 * 365
};

let time_chart_interval = {
  real: 200,
  min: 200,
  hour: 200,
  day: 200,
  week: 500,
  period: 1000,
  month: 200,
  year: 200
};

const gredient_default_color = {
  0.19: "#cccccc",
  0.2864285714285714: "#cccccc",
  0.6078571428571429: "#cccccc",
  0.07928571428571428: "#cccccc",
  0.8578571428571429: "#cccccc",
  0.13642857142857143: "#cccccc",
  0.025714285714285714: "#cccccc",
  0.42928571428571427: "#cccccc"
};

const aks = {
  sdwz: "qhtt0h7gqa618x0h",
  jjwz: "kwkz0amlw7t6dipu",
  yjlwz: "pmyqo8mhvq9lj57n",
  sgtwz: "38gkvs22fbk8sokm",
  hlgwz: "548xeflwnlm7l2m6",
  dltwz: "zp8rebptqocyfuon"
};

export {
  type_name,
  zoomCircleSize,
  timeSpace,
  time_unit_info,
  time_range_std,
  time_chart_interval,
  gredient_default_color,
  aks
};
